import { defineStore } from "pinia";
import dayjs from "../plugins/dayjs";

export const useContextStore = defineStore("context", () => {
  const event = ref(null);

  function setEvent(newEvent) {
    event.value = newEvent;
    if (newEvent) {
      dayjs.setTimezone(newEvent.timezone);
    }
  }

  return {
    event,
    setEvent,
  };
});
